import React, { useState, useEffect } from "react";
import StatsCard from "../../home/cards/StatsCard";
import { StyleSheet, View } from "react-native";
import AppTheme from "../../AppTheme";

export default function ReflectionStatsCard({
  statsCardData,
  controller,
  selectedDate,
  timeUnit,
  parentElement = null,
  changePage = null,
  toggleJournalDialog = () => {},
}) {
  const [statsData, setStatsData] = useState(null);

  // ------------------------------------- METHODS -------------------------------------
  // TODO: Get data from api or general state
  /* const getStatsData = () => {
    const queryDate = moment(selectedDate).format("YYYY-MM-DD");

    const params = {
      reflectionDate: queryDate,
      time_unit: timeUnit,
    };

    controller.getApiData("stats", params, (stats) => {
      if (hasItems(stats)) {
        setStatsData(stats);
      }
    });
  }; */
  // ------------------------------------- END METHODS -------------------------------------

  useEffect(() => {
    if (!selectedDate || !timeUnit) return;

    setStatsData(statsCardData);
  }, [statsCardData, selectedDate, timeUnit]);

  return !statsData ? null : (
    <View style={styles.container}>
      <StatsCard
        controller={controller}
        data={statsData}
        reflectionDate={selectedDate}
        fromReflection
        time_unit={timeUnit}
        parentElement={parentElement}
        changePage={changePage}
        toggleGoalJournalDialog={(el) => toggleJournalDialog(el, false, true)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 8,
    borderTopColor: AppTheme.borderColor,
    borderTopWidth: 1,
  },
});
